import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {endpoints} from '../../../configs/endpoints/endpoint';
import {HttpService} from '@service/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  constructor(private http: HttpService) {
  }

  getMessageTemplates(): Observable<any> {
    return this.http.get(endpoints.crm.preferences.messageTemplate.list);
  }

  getMessageTemplateDetail(messageTemplateId: number): Observable<any> {
    return this.http.get(endpoints.crm.preferences.messageTemplate.detail(messageTemplateId));
  }

  createMessageTemplate(data: any): Observable<any> {
    return this.http.post(endpoints.crm.preferences.messageTemplate.create, {...data});
  }

  updateMessageTemplate(data: any): Observable<any> {
    return this.http.post(endpoints.crm.preferences.messageTemplate.update, {...data});
  }

  deleteMessageTemplate(messageTemplateId: number): Observable<boolean> {
    return this.http.post(endpoints.crm.preferences.messageTemplate.delete, {messageTemplateId});
  }
}
